import { useEffect, useState } from "react";

/**
 * useIsMobile — hook SSR-safe che ritorna true se il viewport è < `breakpoint` px.
 *
 * Diverso da Tailwind responsive classes: qui il render è condizionale in JS
 * → funziona anche se il CSS runtime è alterato (iframe CDN, Tailwind JIT,
 *   estensioni browser che iniettano stylesheet). Robustezza > eleganza.
 */
export default function useIsMobile(breakpoint = 640) {
    const [isMobile, setIsMobile] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.innerWidth < breakpoint;
    });
    useEffect(() => {
        if (typeof window === "undefined") return;
        const check = () => setIsMobile(window.innerWidth < breakpoint);
        check();
        window.addEventListener("resize", check);
        window.addEventListener("orientationchange", check);
        return () => {
            window.removeEventListener("resize", check);
            window.removeEventListener("orientationchange", check);
        };
    }, [breakpoint]);
    return isMobile;
}
